import { useDispatch } from 'react-redux'
import { openSidebar } from '@slices/uiSlice'
import { soundManager } from '@core/audio/sounds/soundManager'

const BurgerMenuModule = () => {
  const dispatch = useDispatch()
  const toggleBurgerMenu = () => {
    soundManager.play('CLICK')
    dispatch(openSidebar())
  }
  return (
    <div className="standard-normal-burger-menu-module-container">
      <div
        className="standard-normal-burger-menu-module-inner-container"
        onClick={toggleBurgerMenu}
      >
        <div className="standard-normal-burger-menu-module-line"></div>
        <div className="standard-normal-burger-menu-module-line"></div>
        <div className="standard-normal-burger-menu-module-line"></div>
      </div>
    </div>
  )
}

export default BurgerMenuModule
